import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useCall } from '../call/CallProvider'
import { apiJson } from '../lib/api'
import { canRecord, type AudioCapabilities } from '../lib/speech'

/**
 * Sesli gorusmeyi baslatan dugme (telefon ikonu).
 *
 * Yalnizca gorusme GERCEKTEN calisabilecekse gorunuyor: sunucuda ses girisi
 * ve sunucu sentezi acik, tarayici kayit yapabiliyor ve sayfa guvenli
 * baglamda (https). Tiklaninca hata veren bir dugme, ozelligin bozuk
 * oldugunu dusundururdu (mikrofon dugmesiyle ayni kural).
 */
export function CallButton({
  conversationId,
  model,
  disabled,
}: {
  conversationId: string | null
  model: string | null
  disabled?: boolean
}) {
  const { t } = useTranslation()
  const call = useCall()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let alive = true
    apiJson<AudioCapabilities>('/api/audio/capabilities')
      .then((caps) => {
        if (alive) setReady(Boolean(caps?.stt?.enabled && caps?.tts?.server))
      })
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [])

  const secure = typeof window === 'undefined' || window.isSecureContext !== false
  if (!call || !ready || !secure || !canRecord()) return null

  return (
    <button
      type="button"
      className="icon-btn"
      onClick={() => call.start({ conversationId, model })}
      disabled={disabled || call.active}
      aria-label={t('call.start')}
      title={t('call.start')}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 4h3.2l1.6 4-2 1.3a11 11 0 0 0 4.9 4.9l1.3-2 4 1.6V17a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
